/**
 * Classroom / org node ids for API paths (e.g. getStudents$/nodeId/:id).
 * Rejects arrays/objects so we never call `/main/students/nodeId/` with a bad segment.
 */
export function normalizeNodeId(value: unknown): number | null {
	if (value == null || value === '') {
		return null;
	}
	if (typeof value === 'number') {
		return Number.isFinite(value) ? value : null;
	}
	if (typeof value === 'string') {
		const n = Number(value.trim());
		return Number.isFinite(n) ? n : null;
	}
	if (Array.isArray(value)) {
		return value.length ? normalizeNodeId(value[0]) : null;
	}
	return null;
}
